import OnePager from './OnePager'

export default OnePager
